module.exports = __webpack_public_path__ + "img/package-delivery-alt.b1b7b475.svg";